"use strict";

const html = document.querySelector('html');

const elements = {
    downloadBox: document.querySelectorAll('.download-wrapper'),
    dynamicImages: document.querySelectorAll('.dynamic-image-box figure'),
    formElements: document.querySelectorAll('main > .box-contact-form .contact-form .form-group'),
    gallery: document.querySelectorAll('.gallery-group .gallery-container .gallery-info, .gallery-group .gallery-container .gallery li'),
    imageBoxes: document.querySelectorAll('.box.image-only'),
    listing: document.querySelectorAll('.listing-container > h2, .listing-default > .listing-item, .listing-container > .paginator'),
    referenceButton: document.querySelectorAll('.listing-container .btn-mehr'),
    referenceThumbs:  document.querySelectorAll('.reference main .reference-thumbs'),
    singleList: document.querySelectorAll('.box.single-listing-item'),
    socialMedia: document.querySelectorAll('footer.social-media .item, footer.social-media .btn-container'),
    standardBoxes: document.querySelectorAll('.box.standard'),
    teaser: document.querySelectorAll('.teaser-group > * > *')
};

html.classList.remove('no-js');
html.classList.add('js');

let options = {
    rootMargin: '200px'
};

window.fadeInObserver = new IntersectionObserver((entries, fadeInObserver) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
        }
    });
}, options);

for (const element of Object.values(elements)) {
    if (element.length !== 0) {
        element.forEach((item) => {
            window.fadeInObserver.observe(item);
        });
    }
}
